const NUMBER_VALIDATION_ERROR = 'Localization Service: invalid number value.';

/**
 * Builds a number from string or number input
 * @param v - Input value
 * @throws {Error} If the input is invalid or cannot be converted to a number
 */
export const buildNumber = (v: string | number): number => {
    if (v === null || v === undefined) {
        throw new Error(`${NUMBER_VALIDATION_ERROR} Value is null or undefined.`);
    }

    // Handle number
    if (typeof v === 'number') {
        if (!Number.isFinite(v)) {
            throw new Error(`${NUMBER_VALIDATION_ERROR} Value is not a finite number: ${v}`);
        }
        return v;
    }

    // Handle string
    if (typeof v === 'string') {
        if (!v.trim()) {
            throw new Error(`${NUMBER_VALIDATION_ERROR} Empty string provided.`);
        }
        const parsed = Number(v);
        if (!Number.isFinite(parsed)) {
            throw new Error(`${NUMBER_VALIDATION_ERROR} Cannot convert to number: ${v}`);
        }
        return parsed;
    }

    throw new Error(`${NUMBER_VALIDATION_ERROR} Unsupported value type: ${typeof v}`);
};
